var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#4267B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9607 12.699L15.2913 10.5437H13.2233V9.14563C13.2233 8.55597 13.5122 7.98058 14.4384 7.98058H15.3786V6.14563C15.3786 6.14563 14.5254 6 13.7096 6C12.0064 6 10.8932 7.03223 10.8932 8.90097V10.5437H9V12.699H10.8932V17.9094C11.6652 18.0302 12.4513 18.0302 13.2233 17.9094V12.699H14.9607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.91eaead88f75b4127737f42e2f77ff1b.svg";
export { ForwardRef as ReactComponent };